import React, { useEffect, useState, useRef } from "react";
import ReactModal from "react-modal";
import axios from "axios";
import Cookies from "universal-cookie";
import Swal from "sweetalert2";
import img from "../IMAGEN/spinner.gif";
import {
  obtenerClasificacion,
  obtenerModalidad,
  obtenerModular,
} from "../Services/Rest";

function CrearSolicitud() {
  const formRef = useRef(null);
  const [isLoading, setLoading] = useState(false);
  const cookie = new Cookies();
  const [modalIsOpen, setIsOpen] = useState(false);
  const [modular, setModular] = useState([]);
  const [clasificacion, setClasificacion] = useState([]);
  const [modalidad, setModalidad] = useState([]);
  const [archivos, setArchivos] = useState(null);

  const [form, setForm] = useState({
    Descripcion: "",
    NombreCliente: "",
    ClasificacionComercial: "",
    Modalidad: "",
    Modular: "",
    NombreCapacitacion: "",
    Duracion: "",
    NumeroParticipantes: "",
    Entregables: "",
    OtrosRequerimientos: "",
    CampoObservacion: "",
  });

  const handleOpenModalTest = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  useEffect(() => {
    axios.get(obtenerModular).then((res) => setModular(res.data));
    axios.get(obtenerClasificacion).then((res) => setClasificacion(res.data));
    axios.get(obtenerModalidad).then((res) => setModalidad(res.data));
  }, []);

  const subirArchivos = (e) => {
    const archivosOriginales = Array.from(e);
    const archivosRenombrados = archivosOriginales.map((file) => {
      const extension = file.name.split(".").pop();
      const nuevoNombre = `${file.name.split(".")[0]}_${Math.floor(
        100000 + Math.random() * 900000
      )}.${extension}`;
      return new File([file], nuevoNombre, { type: file.type });
    });
    setArchivos(archivosRenombrados);
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const insertarArchivos = async (e) => {
    e.preventDefault();

    // Validación HTML5
    if (!formRef.current.reportValidity()) {
      return;
    }

    setLoading(true);

    try {
      let urlAdjunto = "";

      if (archivos && archivos.length > 0) {
        const formData = new FormData();
        archivos.forEach((archivo) => formData.append("files", archivo));

        const response = await axios.post(
          "https://educacionapi.azurewebsites.net/api/AdjuntaArchivos",
          formData
        );
        urlAdjunto = response.data.fileURL;
      }

      const jsonSolicitud = {
        Regional: cookie.get("correoGestor"),
        Descripcion: form.Descripcion,
        Estado: 18,
        NombreCliente: form.NombreCliente,
        Adjunto1: urlAdjunto || "",
        Adjunto2: cookie.get("correoGestor"),
        UsuarioId: parseInt(cookie.get("id")),
        UserIdAsignacion: cookie.get("regional"),
        ClasificacionComercial: form.ClasificacionComercial,
        Modalidad: form.Modalidad,
        Modular: form.Modular,
        NombreCapacitacion: form.NombreCapacitacion,
        Duracion: form.Duracion,
        NumeroParticipantes: form.NumeroParticipantes,
        Entregables: form.Entregables,
        OtrosRequerimientos: form.OtrosRequerimientos,
        CampoObservacion: form.CampoObservacion,
        DetalleEstado: "No Aplica",
        Vencido: 0,
      };

      await axios.post(
        "https://educacionapi.azurewebsites.net/api/CreaSolicitud?correoCreador=" +
          cookie.get("correo"),
        jsonSolicitud
      );

      Swal.fire({
        title: "Añadido con éxito!",
        text: "Haga clic para continuar",
        icon: "success",
      }).then(() => {
        window.location.reload();
      });
    } catch (error) {
      console.error(error);
      Swal.fire({
        title: "Error al crear solicitud",
        text: "Revise la información o intente nuevamente.",
        icon: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="test">
      <button className="btn btn-primary" onClick={handleOpenModalTest}>
        Nueva
      </button>
      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Crear"
      >
        <br></br> <br></br>
        <div className="container">
          <div className="text-center">
            <div className="container-fluid">
              <div className="card shadow mb-4">
                <div className="card-header py-3">
                  <h6 className="m-0 font-weight-bold text-primary">
                    Crear Solicitud
                  </h6>
                </div>
                <div className="card-body">
                  <form
                    ref={formRef}
                    className="user"
                    onSubmit={insertarArchivos}
                  >
                    <input
                      type="text"
                      name="NombreCliente"
                      required
                      className="form-control mb-2"
                      placeholder="Nombre del Cliente"
                      value={form.NombreCliente}
                      onChange={handleChange}
                    />
                    <textarea
                      name="Descripcion"
                      required
                      className="form-control mb-2"
                      placeholder="Descripción"
                      maxLength={600}
                      value={form.Descripcion}
                      onChange={handleChange}
                    />
                    <div className="row mb-2">
                      <div className="col">
                        <select
                          name="ClasificacionComercial"
                          required
                          className="form-control"
                          value={form.ClasificacionComercial}
                          onChange={handleChange}
                        >
                          <option value="">Clasificación Comercial</option>
                          {clasificacion.map((item, idx) => (
                            <option key={idx} value={item.descripcion}>
                              {item.descripcion}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="col">
                        <select
                          name="Modalidad"
                          required
                          className="form-control"
                          value={form.Modalidad}
                          onChange={handleChange}
                        >
                          <option value="">Modalidad</option>
                          {modalidad.map((item, idx) => (
                            <option key={idx} value={item.descripcion}>
                              {item.descripcion}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="row mb-2">
                      <div className="col">
                        <select
                          name="Modular"
                          required
                          className="form-control"
                          value={form.Modular}
                          onChange={handleChange}
                        >
                          <option value="">Modular</option>
                          {modular.map((item, idx) => (
                            <option key={idx} value={item.descripcion}>
                              {item.descripcion}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="col">
                        <input
                          type="text"
                          name="NombreCapacitacion"
                          required
                          className="form-control"
                          placeholder="Nombre de la Capacitación"
                          value={form.NombreCapacitacion}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="row mb-2">
                      <div className="col">
                        <input
                          type="text"
                          name="Duracion"
                          required
                          className="form-control"
                          placeholder="Duración"
                          value={form.Duracion}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="col">
                        <input
                          type="number"
                          name="NumeroParticipantes"
                          required
                          className="form-control"
                          placeholder="Número de Participantes"
                          value={form.NumeroParticipantes}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <textarea
                      name="Entregables"
                      required
                      className="form-control mb-2"
                      placeholder="Entregables"
                      value={form.Entregables}
                      onChange={handleChange}
                    />
                    <textarea
                      name="OtrosRequerimientos"
                      required
                      className="form-control mb-2"
                      placeholder="Otros Requerimientos"
                      value={form.OtrosRequerimientos}
                      onChange={handleChange}
                    />
                    <textarea
                      name="CampoObservacion"
                      required
                      className="form-control mb-2"
                      placeholder="Observaciones"
                      maxLength={600}
                      value={form.CampoObservacion}
                      onChange={handleChange}
                    />
                    <input
                      type="file"
                      className="btn btn-secondary mb-3"
                      onChange={(e) => subirArchivos(e.target.files)}
                      multiple
                    />
                    <hr />
                    {!isLoading ? (
                      <button className="btn btn-primary" type="submit">
                        Guardar
                      </button>
                    ) : (
                      <button className="btn btn-secondary" disabled>
                        <i className="fas fa-spinner fa-spin"></i> Cargando...
                        <img
                          src={img}
                          alt="loading"
                          style={{ width: 70, height: 70 }}
                        />
                      </button>
                    )}
                  </form>
                  <br></br>
                  <button
                    type="submit"
                    className="btn btn-secondary"
                    onClick={closeModal}
                  >
                    volver
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ReactModal>
    </div>
  );
}

export default CrearSolicitud;
